import GridContainer from "@insite/mobius/GridContainer";
import { css } from "styled-components";

GridContainer.defaultProps = {
    css: css`
        margin: 0 auto;
    `
}
